<template>
  <div>
    <el-row :gutter="20">
      <el-form label-width="80px"
               :inline="true"
               :model="orderForm">
        <el-form-item label="订单来源">
          <el-select v-model="orderForm.code"
                     @change="getOrderList(1)"
                     placeholder="请选择来源">
            <el-option label="云天弈"
                       value="yuntianyi"></el-option>
            <el-option label="希施玛"
                       value="csmar"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单时间">
          <el-date-picker v-model="orderForm.dateRange"
                          @change="getOrderList(1)"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-row>
          <el-table v-loading="tableLoading"
                    :data="pageInfo.records"
                    style="width: 100%">
            <el-table-column prop="tableName"
                             label="会员名称">
            </el-table-column>
            <el-table-column prop="orderTime"
                             label="支付时间">
            </el-table-column>
            <el-table-column prop="orderMoney"
                             label="订单金额">
            </el-table-column>
            <el-table-column prop="paymentMoney"
                             label="支付金额">
            </el-table-column>
            <el-table-column prop="schoolName"
                             label="学校名称">
            </el-table-column>
            <el-table-column prop="username"
                             label="学生姓名">
            </el-table-column>
            <!-- <el-table-column label="用户类型"
                                       width="80">
                        <template slot-scope="scope">
                          {{scope.row.roles | rolesTypeFilter}}
                        </template>
                      </el-table-column> -->
            <!-- <el-table-column label="状态"
                             width="60">
              <template slot-scope="scope">
                {{scope.row.status | statusFilter}}

              </template>
            </el-table-column> -->
          </el-table>
        </el-row>
        <el-row>
          <el-pagination background
                         layout="prev, pager, next"
                         @current-change="getOrderList"
                         :total="pageInfo.total">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import axios from 'axios'
import moment from 'moment'
export default {
  name: 'myReports',
  data: function () {
    return {
      tableLoading: true,
      pageInfo: {
        current: 1,
        size: 5,
        records: [],
        total: 1
      },
      schoolSearchForm: {
        name: '',
        code: '',
        proxyId: ''
      },
      orderForm: {
        code: 'yuntianyi',
        dateRange: [new Date(), new Date()]
      },

      sourceId: '',
      activeName: 'price',
      userForm: {
        name: '',
        id: '',
        mobile: '',
        status: 'ENABLE'
      },
      userRules: {},
      optType: 'user',

      reportPageInfo: {
        current: 1,
        size: 10,
        records: [],
        total: 1
      },
      curUserId: '',
      prices: [],
      accountForm: {},
      accountRule: {},
      accountTime: 0,

      taskDialogVisible: false,
      taskForm: {
        type: 'FULL'
      },
      options: [],
      candidateOptions: [],
      conceptOptions: [],
      candidateConcept: [],

      // 学校列表
      schoolPageInfo: {
        current: 1,
        size: 10,
        records: [],
        total: 1
      },

      schoolFrom: {
        refresh: false
      },

      proxyList: [],
      pricePageInfo: {
        page: 1,
        size: 10
      },
      curAddPrice: null,
      priceTable: []

    }
  },
  filters: {
    dateFilter: function (v) {
      return moment(new Date(parseInt(v))).format('YYYY-MM-DD')
    },

    taskStatusFilter: function (v) {
      switch (v) {
        case 'TRUE':
          return '已完成'
        case 'FALSE':
          return '未完成'
        default:
          return v
      }
    },
    typeFilter: function (v) {
      switch (v) {
        case 'FULL':
          return '股票'
        case 'CONCEPT':
          return '概念'
      }
    },
    reportTypeFilter: function (v) {
      switch (v) {
        case 'ALL':
          return '所有'
        case 'FULL':
          return '个股分析（增强版）'
        case 'SIMPLE':
          return '个股分析'
        case 'TINY':
          return '个股分析简报'
        case 'CONCEPT':
          return '概念报告'
        case 'STOCK_COMPARE':
          return '投资组合'
        default:
          break
      }
      return v
    },
    statusFilter: function (v) {
      switch (v) {
        case 'ENABLE':
          return '可用'
        case 'DISABLE':
          return '禁用'
        default:
          return v
      }
    },
    fileTypeFilter: function (v) {
      switch (v) {
        case 'PDF':
          return 'PDF'
        case 'DOC':
          return 'WORD'
        case 'ALL':
          return '所有'

        default:
          return v
      }
    },
    rolesTypeFilter: function (v) {
      switch (v) {
        case 'ADMIN':
          return '管理员'
        case 'NORMAL':
          return '注册用户'
        case 'VIP':
          return 'VIP用户'
        case 'SVIP':
          return '超级VIP'
        default:
          return v
      }
    }
  },
  methods: {

    getOrderList (i) {
      let _this = this
      axios.get('/api/web/admin/orders?code=' + this.orderForm.code + '&page=' + i + '&startDate=' + moment(this.orderForm.dateRange[0]).format('YYYY-MM-DD') + '&endDate=' + moment(this.orderForm.dateRange[1]).format('YYYY-MM-DD')).then(resp => {
        _this.tableLoading = false
        _this.pageInfo = resp.data
        _this.pageInfo.total = parseInt(resp.data.total)
      })
    }
  },
  components: {

  },
  mounted () {
    this.getOrderList(1)
  },
  watch: {

  }
}
</script>
<style scope>
.container-fluid {
  background: url("/static/img/courses-header.jpg");
  height: 400px;
}
.mydropzone {
  background: #0000;
  border: dashed 2px #fff6;
  border-radius: 10px;
  top: 50%;
  position: relative;
}
.mydropzone:focus {
  background: #0000 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/sales.vue